/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FixedPriceContractLineRequest
 */
export interface FixedPriceContractLineRequest {
    /**
     * 
     * @type {string}
     * @memberof FixedPriceContractLineRequest
     */
    lineId?: string;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceContractLineRequest
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceContractLineRequest
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceContractLineRequest
     */
    unitPriceExcludingTaxes: number;
}

/**
 * Check if a given object implements the FixedPriceContractLineRequest interface.
 */
export function instanceOfFixedPriceContractLineRequest(value: object): value is FixedPriceContractLineRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('unitPriceExcludingTaxes' in value) || value['unitPriceExcludingTaxes'] === undefined) return false;
    return true;
}

export function FixedPriceContractLineRequestFromJSON(json: any): FixedPriceContractLineRequest {
    return FixedPriceContractLineRequestFromJSONTyped(json, false);
}

export function FixedPriceContractLineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceContractLineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lineId': json['lineId'] == null ? undefined : json['lineId'],
        'description': json['description'],
        'quantity': json['quantity'],
        'unitPriceExcludingTaxes': json['unitPriceExcludingTaxes'],
    };
}

export function FixedPriceContractLineRequestToJSON(value?: FixedPriceContractLineRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lineId': value['lineId'],
        'description': value['description'],
        'quantity': value['quantity'],
        'unitPriceExcludingTaxes': value['unitPriceExcludingTaxes'],
    };
}

